import { render, staticRenderFns } from "./landing_areas.vue?vue&type=template&id=f970cff6"
import script from "./landing_areas.vue?vue&type=script&lang=js"
export * from "./landing_areas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports